import React, { Component } from "react"
import Swiper from "react-id-swiper"
// eslint-disable-line no-unused-vars

import SvgArrow from "../_svgs/small/Arrow"

import "./_slider.scss" // scss

class Slider extends Component {
  static defaultProps = {
    modifier: "",
  }

  static defaultParams = {
    slideClass: "slider__slide",
    wrapperClass: "slider__wrapper",
    containerClass: "slider__container",
    slidesPerView: 2,
    spaceBetween: 20,
  }

  constructor(props) {
    super(props)

    this.state = {
      prevActive: false,
      nextActive: false,
    }
  }

  updateSwiper = (swiper) => {
    this.swiper = swiper

    if (this.swiper) {
      this.swiper.on("reachBeginning", this.slideChangeHandler)
      this.swiper.on("reachEnd", this.slideChangeHandler)
      this.swiper.on("fromEdge", this.slideChangeHandler)

      this.slideChangeHandler()
    }
  }

  nextHandler = () => {
    if (this.swiper !== null && !this.swiper.isEnd) {
      this.swiper.slideNext()
    }
    if (this.swiper.isEnd) this.setState({ nextActive: false })
    if (!this.swiper.isBeginning) this.setState({ prevActive: true })
  }

  prevHandler = () => {
    if (this.swiper !== null && !this.swiper.isBeginning) {
      this.swiper.slidePrev()
    }
    if (this.swiper.isBeginning) this.setState({ prevActive: false })
    if (!this.swiper.isEnd) this.setState({ nextActive: true })
  }

  slideChangeHandler = () => {
    // console.log("slideChangeHandler. beginning:"+this.swiper.isBeginning+" | end:"+this.swiper.isEnd);

    if (this.swiper.isBeginning) this.setState({ prevActive: false })
    else this.setState({ prevActive: true })

    if (this.swiper.isEnd) this.setState({ nextActive: false })
    else this.setState({ nextActive: true })
  }

  render() {
    let params = Object.assign(Slider.defaultParams, this.props.params)

    return (
      <div className={`slider ${this.props.modifier}`}>
        <button onClick={this.prevHandler} className={`slider__prev ${this.state.prevActive ? "" : "is-hidden"} `}>
          <span className="svg-icon">
            <SvgArrow />
          </span>
        </button>
        <Swiper {...params} getSwiper={this.updateSwiper} slideChange={this.slideChangeHandler}>
          {this.props.children}
        </Swiper>
        <button onClick={this.nextHandler} className={`slider__next ${this.state.nextActive ? "" : "is-hidden"} `}>
          <span className="svg-icon">
            <SvgArrow />
          </span>
        </button>
      </div>
    )
  }
}

export default Slider
